<template>
  <flat-pickr
    :config="datePickerConfig"
    v-model="selectedDate"
    placeholder="Choose arrival date and time"
    class="p-3 s-inputx vs-input--input flex"
    :disabled="disableComponent"
  />
</template>

<script>
import flatPickr from "vue-flatpickr-component";
import moment from "moment";

export default {
  components: {
    flatPickr,
  },
  props: {
    arrivalDate: String,
    disableComponent: Boolean
  },
  data() {
    return {
      //dateString: undefined,
      datePickerConfig: {
        enableTime: true, // Set to true for time again
        enableSeconds: false,
        noCalendar: false,
        time_24hr: true,
        dateFormat: "Y-m-d H:i", // "d-m-Y H:i" for time 2021-11-19T19:00:00Z
      },
    };
  },
  computed: {
    selectedDate: {
      get() {
        return this.arrivalDate;
      },
      set(newValue) {
        if (newValue) {
          const date = moment(newValue);
          let dateString = date.toJSON();

          this.$emit("arrival-date-selected", dateString);
        }
      },
    },
  },
  methods: {},
};
</script>

<style lang="scss" scoped>
</style>
